import Avatar from '@mui/material/Avatar'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'
import React, { FC } from 'react'
import { theme } from '../../lib/styles/universal'
import { makeStyles } from 'tss-react/mui'
import { RPUser } from '@hazadapt-git/public-core-base'
import { TeamMemberTypeIcon } from '../molecules'

interface ProfileOverviewProps {
    user: RPUser
    onChangeProfilePictureClick: React.MouseEventHandler
}

export const ProfileOverview: FC<ProfileOverviewProps> = ({
    user,
    onChangeProfilePictureClick,
}) => {
    const { classes: localClasses } = useLocalStyles()

    return (
        <div className={localClasses.container}>
            <Avatar
                src={user.profile_picture_uri ?? undefined}
                sx={{
                    width: {
                        xs: '5rem',
                        md: '7rem',
                    },
                    height: {
                        xs: '5rem',
                        md: '7rem',
                    },
                }}
                alt={
                    user.profile_picture_uri
                        ? `${user.first_name}'s profile picture`
                        : `Default profile picture for ${user.first_name} ${user.last_name}`
                }
            />
            <div className={localClasses.textContainer}>
                <Typography variant="h4">
                    {user.first_name} {user.last_name}
                </Typography>
                <Typography className={localClasses.userTitle}>
                    {user.title}
                </Typography>
                <TeamMemberTypeIcon user={user} showType />
            </div>
            <Link component="button" onClick={onChangeProfilePictureClick}>
                Change Profile Picture
            </Link>
        </div>
    )
}

const useLocalStyles = makeStyles()({
    container: {
        display: 'grid',
        gridTemplateColumns: '5rem 1fr',
        alignItems: 'center',
        gap: '0.5rem',
        [theme.breakpoints.up('md')]: {
            gridTemplateColumns: '7rem 1fr',
        },
    },
    avatarContainer: {
        width: 'min-content',
        display: 'flex',
        flexDirection: 'column',
        gap: '0.5rem',
    },
    textContainer: {
        paddingLeft: '1rem',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-evenly',
        alignItems: 'flex-start',
        gap: '0.5rem',
    },
    userTitle: {
        fontWeight: 600,
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
    },
})
